import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { concentracionEntity } from './../entities_riesgos/entities_riesgos';
import {ConcentracionService} from './../../../services/riesgo-credito/riesgos/concentracion.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { IMG } from '../../../services/imagen/png';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import { formatear } from '../../funciones/funcionesGenerales';
import { CapitalizePipe } from '../../../components/pipes/capitalize.pipe';

import moment from 'moment';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';

@Component({
  selector: 'app-concentracion',
  templateUrl: './concentracion.component.html',
  styleUrl: './concentracion.component.css'
})
export class ConcentracionComponent implements OnInit{
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public Filtros = FiltersM;
  
  // **** NUevo tipo de filtrado ****
  filtroNorm = true;
  nperiodos = 12;
  // **** Cambio de miles a pesos ****
  miles1 = true;
  miles2 = true;
  milTab1 = '(Miles)';
  milTab2 = '(Miles)';
  // **** Variables de titulos y subtitulos ****
  pop = false;
  elemagrup = 'Sucursal';
  encGroup = 'Oficinas';
  eslAgrupSec = true;
  eslAgrupSuc = false;
  eslAgrupZon = false;
  eslAgrupGen = false;
  eslAgrupEstat = false;
  eslAgrupGar = false;
  elemagrup2 = 'TipoCredito';
  titElemagrup2 = 'Tipo de crédito';
  eslAgrupPro = false;
  eslAgrupBan = true;
  // **** Variables del web service ****
  concentracion = new concentracionEntity;
  periodo = 22022;
  // **** Variables de los contenedores de datos ****
  stack : any = [];
  DatosProduct : any;
  data: any = [];
  datTab1 = [];
  datTab2 = [];
  DatosBanda : any = [];
  public idInstitucion: number;
  public DatosAnios;
  public aniosDisponibles: any [];
  public mesesDisponibles: any [];
  public mes = 'feb';
  public anio = '2022';
  TituloGrafPrinc = ' Concentración por '+ this.encGroup;
  subTituloGrafPrinc = this.anio.substring(2,4) + ' | '  + this.mes +' | matriz';
  TituloGrafSec = ' Concentración por '+this.titElemagrup2;
  subTituloGrafSec = this.anio.substring(2,4) + ' | '  + this.mes +' | matriz';
  TituloGrafTer = 'Concentración por categoría';
  subTituloGrafTer = this.anio.substring(2,4) + ' | '  + this.mes +' | matriz';
  // **** Variables del metodo de separacion de datos ****
  separador:string =  ","; // separador para los miles
  sepDecimal:string = '.'; // separador para los decimales
  // **** VAriables de tabla
  Titulos : any = [];
  displayedColumns: string[] = ['periodo', 'servicios'];
  displayedColumns2: string[] = ['periodo', 'servicios',  'producto1',  'producto2',  'producto3','producto4'];
  dataSource : any = [];
  dataSource2 : any = [];
  //Variables de graficas de barras
  xAxisLabel: string = 'Meses';
  yAxisLabel: string[] = ['Porcentaje'];
  xAxisLabel2: string = 'Porcentaje';
  yAxisLabel2: string[] = ['Meses'];
  xAxisLabel3: string = 'Porcentaje';
  yAxisLabel3: string[] = ['Meses'];
  // colorScheme : any = ['#007196', '#0090bf', '#39b1c6', '#7ac2d9', '#a0daec', '#b1e6f2'];
  colorScheme : any = ['#6BAED6', '#A6D9C9', '#C5B0D5', '#F7B267', '#FEE191', '#BFD8B8', '#A8CBE8', '#F6A6A1', '#8FD8D2', '#7BAEBE' ];
  public tipoGraf = typesApex;
  public tipoSelec = this.tipoGraf.STACKED;
  public showLabels = false;
  public etiquetas = [];
  public changeLabel: boolean = true;
  public tipoSelec2 = this.tipoGraf.STACKEDHORIZONTAL;
  public showLabels2 = false;
  public etiquetas2 = [];
  public tipoSelec3 = this.tipoGraf.DONUT;
  public showLabels3 = false;
  public etiquetas3 = [];
  // **** Variables de activación de graficas normales y del modal ****
  Title = '';
  Subtitulo_grafica = '';
  
  gtablaP = false;
  gtablaPModal = false;
  tablaBandasModal = false;
  tablaBandas = false;
  gtablas = false;
  gtablasModal = false;
  
  public zona: number;
  // VARIABLES PERSONALIZACION CATALAGO
  private bndInteres: boolean; // false -> sin intereses   true -> con intereses
  public submenus: number; 
  public smMoneda: String;
// **** Constructor ****
  constructor(
    private concentracionService: ConcentracionService,
    public dataService: DataService,
    private translate: TranslateService,
    private excelservices: ExcelService,
    private periodosService: PeriodosService,
    private cookies: CookieService
  ){
    this.idInstitucion = Number(cookies.get('idInstitucion'));
    formatear.momentAbrev();
    this.personalizacion();
    this.getPeriodos();
  }
  ngOnInit(): void {
  }
  public filterChange(filtro){
    this.perspectiva(filtro.filtro, filtro.elem);
  }
  public filterChange2(filtro){
    this.perspectiva2(filtro.filtro, filtro.elem);
  }
  private personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
    this.smMoneda = configInst.moneda;
    if(this.idInstitucion === 2){
      this.elemagrup = 'Sector';
      this.encGroup = 'Sector';
      this.elemagrup2 = 'Producto';
      this.titElemagrup2 = 'Producto';
    }else{
      this.elemagrup = 'Sucursal';
      this.encGroup = 'Oficinas';
      this.elemagrup2 = 'TipoCredito';
      this.titElemagrup2 = 'Tipo de Crédito';
    }
  }
  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    if(info.length > 0){
      this.DatosAnios = formatear.periodosRC(info);
      this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
      this.mes = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].name;
      this.anio = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].year;
      this.DatosAnios.aniosDisponibles[this.DatosAnios.aniosDisponibles.length-1].check = true;
      this.FuncionesDataSource();
      this.getDatos();
    }else{
      var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }
    
  }
  // **** Funciones del web service y tratamiento de datos
  public FuncionesDataSource(){
    this.concentracion.InstitucionId = this.idInstitucion;
    this.concentracion.Periodo = this.periodo;
    this.concentracion.ElementoAgrupador = this.elemagrup;//'Zona';
    this.concentracion.NPeriodos = this.nperiodos;
    this.concentracion.NDatosLimite= 3;
    // this.concentracion.BnIntereses = this.bndInteres;
    this.funcionConcentracionSector(this.concentracion);
    this.concentracion.ElementoAgrupador = this.elemagrup2;
    this.funcionConcentracionProducto(this.concentracion);
    this.concentracion.ElementoAgrupador = 'CategoriaCredito';
    this.funcionConcentracionBandas(this.concentracion);
    this.actsubtitulos();
  }
  async funcionConcentracionSector(concentracionEntity: any){
    try{
      const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',concentracionEntity)); 
      var aux = [];
      for(let p of res){
        aux.push(p);
      }
      this.Datos(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async funcionConcentracionProducto(concentracionEntity: any){
    try{
      const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',concentracionEntity)); 
      var aux = [];
      for(let p of res){
        aux.push(p);
      }
      this.DatosProducto(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async funcionConcentracionBandas(concentracionEntity: any){
    try{
      const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',concentracionEntity)); 
      var aux = [];
        for(let p of res){
          aux.push(p);
        }    
      this.DatosBandas(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  filtroAnios(arreglo: any){
    var aux =[];
    for(var i = 0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].check == true){
        var nameT = this.DatosAnios.mesesDisponibles[i].name+' '+this.DatosAnios.mesesDisponibles[i].year.substr(2,2);
        for(var j = 0; j<arreglo.length; j++){
          if(arreglo[j].name == nameT){
            aux.push(arreglo[j]);
            break;
          }
        }
      }
    }
    var aux2 = [];
    for(var i = aux.length-1; i>=0; i-- ){
      aux2.push(aux[i]);
    }
    return aux2;
  }
  seleccionarmes(mes: any){
    for(var i = 0; i< this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].name == mes.name && this.DatosAnios.mesesDisponibles[i].year == mes.year){
        this.DatosAnios.mesesDisponibles[i].check = !this.DatosAnios.mesesDisponibles[i].check;
      }
    }
    for(var i = this.DatosAnios.mesesDisponibles.length-1; i>=0; i-- ){
      if(this.DatosAnios.mesesDisponibles[i].check == true){
        this.mes = this.DatosAnios.mesesDisponibles[i].name;
        this.anio = this.DatosAnios.mesesDisponibles[i].year;
        break;
      }
    }
    this.FuncionesDataSource();
  }
  Datos(arreglo: any []){
    if(!this.filtroNorm){
      const perS = this.DatosAnios.mesesDisponibles.filter(e => e.check === true);
      arreglo = perS.flatMap(p =>
        arreglo.filter(c => c.Periodo === Number(p.value))
      );
    }
    arreglo = arreglo.sort((a,b) => b.Periodo - a.Periodo);
    this.DatosTablasec(arreglo);
    const info = [...arreglo];
    const periodos = [ ...new Set(info.map( item => item.Periodo)) ];
    const elemAgrup = [ ...new Set(info.map( item => item.ElementoAgrupador)) ];
    this.etiquetas = periodos.map(e => moment(e,'YYYYMM').format('MMM YY')).reverse();
    var auxFinal = []
    elemAgrup.forEach( ele => {
      // const dat = info.filter( i => i.ElementoAgrupador === ele);
      const data = periodos.map(p => {
        const found = info.find(i =>  i.ElementoAgrupador === ele && i.Periodo === p);
        return found ? found.Saldo_Actual : 0;
      })
      // const data = dat.map( e => e.Saldo_Actual).reverse();
      auxFinal.push({
        name: ele,
        data: data
      })
    })
    this.Titulos = elemAgrup;
    this.stack = auxFinal;
  }
  DatosProducto(arreglo: any []){
    if(!this.filtroNorm){
      const perS = this.DatosAnios.mesesDisponibles.filter(e => e.check === true);
      arreglo = perS.flatMap(p =>
        arreglo.filter(c => c.Periodo === Number(p.value))
      );
    }
    arreglo = arreglo.sort((a,b) => b.Periodo - a.Periodo);
    const info = [...arreglo];
    const periodos = [ ...new Set(info.map( item => item.Periodo)) ];
    const elemAgrup = [ ...new Set(info.map( item => item.ElementoAgrupador)) ];
    this.etiquetas2 = periodos.map(e => moment(e,'YYYYMM').format('MMM YY'));
    var auxFinal = []
    elemAgrup.forEach( ele => {
      // const dat = info.filter( i => i.ElementoAgrupador === ele);
      const dat = periodos.map(p => {
        const found = info.find(i => i.ElementoAgrupador === ele && i.Periodo === p);
        return found ? found.Saldo_Actual : 0; // Valor por defecto si no existe
      });
      // const data = dat.map( e => e.Saldo_Actual).reverse();
      auxFinal.push({
        name: ele,
        data: dat
      })
    })
    this.DatosProduct = auxFinal;
    this.DatosTabla(arreglo);
  }
  DatosBandas(arreglo: any []){
    this.etiquetas3 = []
    arreglo = arreglo.sort((a,b) => b.Periodo - a.Periodo);
    const info = [...arreglo];
    const d = info.filter(i => moment(i.Periodo,'YYYYMM').format('MMM YYYY').toLocaleLowerCase() === `${this.mes} ${this.anio}`);
    var elemAgrup = [ ...new Set(info.map( item => item.ElementoAgrupador)) ];
    this.etiquetas3 = elemAgrup.sort();
    var auxFinal = []
    var aux = []
    d.forEach( ele => {
      aux.push(ele.Saldo_Actual);      
    })
    auxFinal.push({
      name: 'a',
      data: aux,
    })
    var auxt = [];
    for(var i= 0; i<this.etiquetas3.length; i++){
      auxt.push({name: this.etiquetas3[i], value: aux[i]});
    }
    this.DatosBanda = auxt;
    this.data = auxFinal;
  }
  Nombre(nombre: any){
    if(nombre == 'Sin Datos'){
      return 'Persona moral';
    }else{
      return nombre;
    }
  }
  DatosTablasec(arreglo: any []){
    this.datTab2 = [];
    var aux = [];
    var j=0;
    for(var i= 0; i<arreglo.length; i++){
      if( i>0){
        if(arreglo[i].Periodo == arreglo[(i-1)].Periodo){
          aux[(j)].series.push( {name: arreglo[i].ElementoAgrupador, value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH} );
        }else{
          aux.push({name: moment(arreglo[i].Periodo, 'YYYYMM').format('MMM YY'), series: [{ name: this.Nombre(arreglo[i].ElementoAgrupador) , value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH}]});
          j++;
        }
        }else{
        aux.push({name: moment(arreglo[i].Periodo, 'YYYYMM').format('MMM YY'), series: [{ name: this.Nombre(arreglo[i].ElementoAgrupador) , value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH}]});
      }
    }
    if(!this.filtroNorm){
      aux = this.filtroAnios(aux);
    }
    var datTab = aux;
    var aux2 = [];
    aux = [];
    for(var i = 0; i < datTab.length;i++){
      for(var j =0; j< datTab[i].series.length; j++){
        aux2.push({name: datTab[i].series[j].name, saldo: datTab[i].series[j].value, ihh: datTab[i].series[j].ihh});
      }
      aux.push({name: datTab[i].name, series: aux2});
      aux2=[];
    }
    this.datTab2 = aux;

    this.displayedColumns2 = ['periodo', 'servicios'];
    var json = '['
    for(var i =0; i< aux.length; i++){
      json +='{';
      json +='"name": "' + aux[i].name+'", "servicios": "Saldo_Actual:", "servicios1": "IHH:",';
      for(var j = 0; j < aux[i].series.length; j++){
        if(i===0){
          this.displayedColumns2.push('producto'+ (j>=9?'0':'') +(j+1))
        }
        json +='"producto'+ (j>=9?'0':'') + (j+1)+'": ' + aux[i].series[j].saldo+', ';
        json +='"producto'+ (j>=9?'0':'') + (j+1)+'1": ' + aux[i].series[j].ihh;
        if(j !== aux[i].series.length-1){
          json +=', ';
        }
      }
      json +='}';
      if(i !== aux.length-1){
        json +=', ';
      }
    }
    json +=']';
    aux2 = JSON.parse(json)

    this.dataSource2 = aux2;
  }
  DatosTabla(arreglo: any []){
    this.dataSource = [];
    var aux = [];
    var j=0;
    for(var i= 0; i<arreglo.length; i++){
      if( i>0){
        if(arreglo[i].Periodo == arreglo[(i-1)].Periodo){
          aux[(j)].series.push( {name: arreglo[i].ElementoAgrupador, value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH} );
        }else{
          aux.push({name: moment(arreglo[i].Periodo, 'YYYYMM').format('MMM YY'), series: [{ name: arreglo[i].ElementoAgrupador , value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH}]});
          j++;
        }
        }else{
        aux.push({name: moment(arreglo[i].Periodo, 'YYYYMM').format('MMM YY'), series: [{ name: arreglo[i].ElementoAgrupador , value: arreglo[i].Saldo_Actual,ihh: arreglo[i].IHH}]});
      }
    }
    if(!this.filtroNorm){
      aux = this.filtroAnios(aux);
    }
    var datTab = aux;
    var aux2 = [];
    var aux2R = [];
    aux = [];
    for(var i = 0; i < datTab.length;i++){
      for(var j =0; j< datTab[i].series.length; j++){
        aux2.push({name: datTab[i].series[j].name, saldo: datTab[i].series[j].value, ihh: datTab[i].series[j].ihh});
      }
      aux.push({name: datTab[i].name, series: aux2});
      aux2=[];
    }
    this.datTab1 = aux;

    var products = [];
    for(const d of aux){
      for(const p of d.series){
        const ex = products.filter(pp => pp === p.name);
        if(ex.length===0){
          products.push(p.name)
        }
      }
    }
    this.displayedColumns = ['periodo', 'servicios'];
    for(var i =0; i< aux.length; i++){
      let a = {periodo: aux[i].name, servicios: 'Saldo_Actual:', servicios1: 'IHH:',};
      let num = 1;
      for(const d of products){
        const dat = aux[i].series.filter(p => p.name === d);
        if(dat.length !== 0){
          a['name'] = products;
          a['producto'+(num>9?0:'')+''+num] = dat[0].saldo;
          a['producto'+(num>9?0:'')+''+num+'1'] = dat[0].ihh;   
        }else{
          a['name'] = products;
          a['producto'+(num>9?0:'')+''+num] = '';
          a['producto'+(num>9?0:'')+''+num+'1'] = '';
        }
        
        if(i === 0){
          this.displayedColumns.push('producto'+(num>9?0:'')+''+num);
        }
        num++;
      }
      aux2.push(a)
    }
    this.dataSource = aux2;
  }
  perspectiva(agrup: any, enc){
    this.elemagrup = enc;
    this.encGroup = agrup;
    this.concentracion.ElementoAgrupador = this.elemagrup;
    this.funcionConcentracionSector(this.concentracion);
    this.actsubtitulos();
    
    if(this.elemagrup == 'Sucursal'){
      this.eslAgrupSuc = true;
      this.eslAgrupSec = false;
      this.eslAgrupZon = false;
      this.eslAgrupGen = false;
      this.eslAgrupEstat = false;
      this.eslAgrupGar = false;
    }
    if(this.elemagrup == 'Sector'){
      this.eslAgrupSuc = false;
      this.eslAgrupSec = true;
      this.eslAgrupZon = false;
      this.eslAgrupGen = false;
      this.eslAgrupEstat = false;
      this.eslAgrupGar = false;
    }
    if(this.elemagrup == 'Zona'){
      this.eslAgrupSuc = false;
      this.eslAgrupSec = false;
      this.eslAgrupZon = true;
      this.eslAgrupGen = false;
      this.eslAgrupEstat = false;
      this.eslAgrupGar = false;
    }
    if(this.elemagrup == 'Genero'){
      this.eslAgrupSuc = false;
      this.eslAgrupSec = false;
      this.eslAgrupZon = false;
      this.eslAgrupGen = true;
      this.eslAgrupEstat = false;
      this.eslAgrupGar = false;
    }
    if(this.elemagrup == 'EstatusCredito'){
      this.eslAgrupSuc = false;
      this.eslAgrupSec = false;
      this.eslAgrupZon = false;
      this.eslAgrupGen = false;
      this.eslAgrupEstat = true;
      this.eslAgrupGar = false;
    }
    if(this.elemagrup == 'Garantia'){
      this.eslAgrupSuc = false;
      this.eslAgrupSec = false;
      this.eslAgrupZon = false;
      this.eslAgrupGen = false;
      this.eslAgrupEstat = false;
      this.eslAgrupGar = true;
    }
  }
  perspectiva2(agrup: any, tit){
    this.elemagrup2 = tit;
    this.titElemagrup2 = this.translate.instant(agrup);
    this.concentracion.ElementoAgrupador = this.elemagrup2;
    this.funcionConcentracionProducto(this.concentracion);
    this.actsubtitulos();
    if(this.elemagrup2 == 'Producto'){
      this.eslAgrupPro = true;
      this.eslAgrupBan = false;
    }else{
      this.eslAgrupPro = false;
      this.eslAgrupBan = true;
    }
  }
  // **** Funciones de Filtros ****
  getDatos(){
    this.aniosDisponibles = this.DatosAnios.aniosDisponibles;
    var aux = [];
    var pos;
    for(var i = 0; i < this.aniosDisponibles.length; i ++){
      if(this.aniosDisponibles[i].check == true){
        pos = i;
      }
    }
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
  }
  /* funciones para los filtros */
  cambioFiltro(){
    if(this.filtroNorm){
      this.filtroNorm = false;
      for(var i = this.DatosAnios.mesesDisponibles.length-1; i>this.DatosAnios.mesesDisponibles.length-12; i--){
        this.DatosAnios.mesesDisponibles[i].check = true;
      }
      for(var i = 0; i<this.DatosAnios.aniosDisponibles.length; i++){
        this.DatosAnios.aniosDisponibles[i].check = false;
      }
      this.nperiodos = this.DatosAnios.mesesDisponibles.length;
      this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
    }else{
      for(var i = 0; i<this.DatosAnios.aniosDisponibles.length; i++){
        this.DatosAnios.aniosDisponibles[i].check = false;
      }
      this.filtroNorm = true;
      for(var i = 0; i<this.DatosAnios.mesesDisponibles.length; i++){
        this.DatosAnios.mesesDisponibles[i].check = false;
      }
      this.DatosAnios.aniosDisponibles[this.DatosAnios.aniosDisponibles.length-1].check = true;
      this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].check = true;
      this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
      this.mes = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].name;
      this.anio = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].year;
      this.nperiodos = 12;
    }
    this.FuncionesDataSource();
  }
  anioEsc(anio: any){
    return anio[2]+''+anio[3];
  }
  //AÑOS
  public anioChange(anio: any){
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    for(var i =0; i < this.aniosDisponibles.length; i++){
      if(this.aniosDisponibles[i].value == anio.value){
        this.aniosDisponibles[i].check = true;
        pos = i;
      }
    }
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.FuncionesDataSource();
  }
  public mesChange(mes: any){
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var pos =0;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      if(this.mesesDisponibles[i].name == mes.name){
        this.mesesDisponibles[i].check = true;
        pos = i;
      }
    }
    this.mes = this.mesesDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[pos].value);
    this.FuncionesDataSource();
  }
  quitar_filtros(){
    var pos = 0;
    this.DatosAnios.mesesDisponibles.forEach(mes => mes.check=false);
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[this.aniosDisponibles.length-1].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[this.aniosDisponibles.length-1].name;

    this.gtablaP = false;
    this.gtablaPModal = false;
    this.gtablas = false;
    this.gtablasModal = false;
    this.tablaBandas = false;
    this.tablaBandasModal = false;    

    this.elemagrup = 'Sucursal'
    this.eslAgrupSec = true;
    this.eslAgrupZon = false;
    this.eslAgrupSuc = false;
    this.elemagrup2 = 'TipoCredito';
    this.titElemagrup2 = this.translate.instant('persp.pers12')
    this.eslAgrupPro = true;
    this.eslAgrupBan = false;

    this.miles1 = true;
    this.miles2 = true;
    this.milTab1 = '(Miles)';
    this.milTab2 = '(Miles)';
    this.filtroNorm = true;
    this.nperiodos = 12;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);

    this.tipoSelec = this.tipoGraf.STACKED;
    this.showLabels = false;
    this.changeLabel = true;
    this.tipoSelec2 = this.tipoGraf.STACKEDHORIZONTAL;
    this.showLabels2 = false;
    this.tipoSelec3 = this.tipoGraf.DONUT;
    this.showLabels3 = false;

    this.personalizacion();
    this.FuncionesDataSource();
  }
  actsubtitulos(){
    this.TituloGrafPrinc = ' Concentración por '+this.encGroup;
    this.TituloGrafSec = ' Concentración por '+this.titElemagrup2;
    this.subTituloGrafPrinc = this.mes + ' • '  + this.anio.substring(2,4) +' | matriz';
    this.subTituloGrafSec = this.mes + ' • '  + this.anio.substring(2,4) +' | matriz';
    this.subTituloGrafTer = this.mes + ' • '  + this.anio.substring(2,4) +' | matriz';
  }
  // **** Función de formateo de numeros ****
  formatearnormal2(num: any){
    num = Number(num).toFixed(2);
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft +splitRight;
  }
  formatearnormal(num: any, miles: any){
    if(miles == true)
      num = (num/1000).toFixed(2)
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
      return  splitLeft;
  }
  CambMon( moneda: any, tab: any ){
    if(moneda == 'Mil' && tab == 1){
      this.miles1 = true;
      this.milTab1 = '(Miles)';
    }
    if(moneda == 'Mil' && tab == 2){
      this.miles2 = true;
      this.milTab2 = '(Miles)';
    }
    if(moneda == 'Pesos' && tab == 1 ){
      this.miles1 = false;
      this.milTab1 = '';
    }
    if(moneda == 'Pesos' && tab == 2 ){
      this.miles2 = false;
      this.milTab2 = '';
    }
    this.FuncionesDataSource();
  }
  // **** Exportar ****
  export_csv(tab: any){
    var aux = [];
    var data_excel: any = [];
    var name = '';
    var encabezado_excel = [];
    var per = ` ${this.mes} ${this.anio}`;
    
    let nombreArch = "";
    let nombre = "";
    if(tab == 1){
      encabezado_excel.push(this.translate.instant('filtros.periodo'));
      encabezado_excel.push('');
      let c = 0;
      for(const i of this.dataSource2){
        let ind = 0;
        for(const d of this.displayedColumns2){
          switch(ind){
            case 0:
              aux.push(i.name);break;
            case 1: 
              aux.push(i.servicios); break;
            default:
              aux.push(i[d]);
          }
          if(ind >= 2 && c === 0){
            encabezado_excel.push(this.Titulos[ind-2]);
          }
          ind++;
        }
        data_excel.push(aux);
        aux = [];
        ind = 0;
        for(const d of this.displayedColumns2){
          switch(ind){
            case 0:
              aux.push('');break;
            case 1: 
              aux.push(i.servicios1); break;
            default:
              aux.push(i[d+'1']);
          }
          ind++;
        }
        data_excel.push(aux);
        aux = [];
        c++;
      }
      if(this.gtablaP){
        nombreArch = this.TituloGrafPrinc;
        nombre = this.TituloGrafPrinc + " " + this.subTituloGrafPrinc;
      }
      if(!this.gtablaP){
        nombreArch = this.TituloGrafPrinc;
        nombre = this.TituloGrafPrinc  + " " + this.subTituloGrafPrinc;
      }
      name = this.elemagrup;
    }else{
      let aux2 = [];
      encabezado_excel = ['Periodo',''];
      for(const p of this.dataSource[0].name){
        encabezado_excel.push(p)
      }
      for(const dat of this.dataSource){
        let i = 0;
        for(const tit of this.displayedColumns){
          aux.push(dat[''+tit]);
          aux2.push(i!==0?dat[''+tit+'1']:'');
          i++;
        }
        data_excel.push(aux);
        data_excel.push(aux2);
        aux = [];
        aux2 = [];
      }
      var cadena_evaluacion = this.datTab1[0].series;
      name = this.titElemagrup2;
      if(this.gtablas){
        nombreArch = this.TituloGrafSec;
        nombre = this.TituloGrafSec + " " + this.subTituloGrafSec;
      }
      if(!this.gtablas){
        nombreArch = this.TituloGrafSec;
        nombre = this.TituloGrafSec  + " " + this.subTituloGrafSec;
      }
    }
    nombreArch += per;
    let titHoja = this.translate.instant('menu.'+this.dataService.moduleSelect) + " " + nombre; 
    this.excelservices.generateExcelConcentracion(titHoja,encabezado_excel,data_excel,nombreArch);
  }
  export_img(zon: any){
    var name = {titulo: '', subtitulo:'', nombreArch: ''};
    if(zon == 1){
      name.titulo = this.TituloGrafPrinc;
      name.subtitulo = this.subTituloGrafPrinc;
      name.nombreArch = this.TituloGrafPrinc;
    }
    if(zon == 2){
      name.titulo = this.TituloGrafSec;
      name.subtitulo = this.subTituloGrafSec;
      name.nombreArch = this.TituloGrafSec;
    }
    if(zon == 3){
      name.titulo = this.TituloGrafTer;
      name.subtitulo = this.subTituloGrafTer;
      name.nombreArch = this.TituloGrafTer;
    }
    const comp = this.grafCmp.find(g => g.zona === zon);
    comp.exportImg(zon,name)
  }
  // **** Funciones de Activación de graficas normales y Ampliadas
  //Segunda pagina
  stackTabla(acc,tipo){
    this.tipoSelec = !acc ? tipo : this.tipoSelec;
    this.gtablaP = acc;
  }
  stackHoriTabla(acc,tipo){
    this.tipoSelec2 = !acc ? tipo : this.tipoSelec2;
    this.gtablas = acc;
  }
  tableBandas(acc,tipo){
    this.tipoSelec3 = !acc ? tipo : this.tipoSelec3;
    this.tablaBandas = acc;
  }
  ampliar(){
    this.Title = this.TituloGrafPrinc;
    this.Title += this.gtablaP ? ` ${this.milTab1}` : '';
    this.Subtitulo_grafica = this.subTituloGrafPrinc;
    this.gtablaPModal = this.gtablaP ? true : false;
    this.zona = 1;
  }
  ampliarG2(){
    this.Title = this.TituloGrafSec;
    this.Title += this.gtablas ? ` ${this.milTab2}` : '';
    this.Subtitulo_grafica = this.subTituloGrafSec;
    this.gtablasModal = this.gtablas ? true : false;
    this.zona = 2;
  }
  ampliarG3(){
    this.Title = this.TituloGrafTer;
    this.Subtitulo_grafica = this.subTituloGrafTer;
    this.tablaBandasModal = this.tablaBandas ? true : false;
    this.zona = 3;
    document.getElementById('graficasModal').classList.add("show");
    setTimeout(() => {
      const comp = this.grafCmp.find(g => g.zona === 6);
      if (comp) {
        comp.changeFontSize();
      } else {
      }
    }, 200);
  }
  cerrarAmp(){
    this.gtablaPModal = false;
    this.gtablasModal = false;
    this.tablaBandasModal = false;
  }
  popChange(){
    this.pop = !this.pop;
  }
  public aniosSelec(){
    var i = 0;
    let element = document.getElementById('contenedor_btnanios')
    this.DatosAnios.mesesDisponibles.forEach( an => { if(an.check){ i++; }});
    if(element.offsetWidth > 600)
      return i>7
    return i>6
  }
  public exportBandas(){
    var titulos = [
      this.translate.instant('riesgo-credito.concentracion.titBanda'),
      this.translate.instant('riesgo-credito.concentracion.titVal')
    ]

    var alineacion = [Aligment.CENTER, Aligment.RIGHT];
    var formato = [FormatText.TEXT, FormatText.NUMBER];

    var data = [];
    for(const d of this.data){
      var aux = [];
      aux.push(d.name);
      aux.push(d.value);
      data.push(aux);
    }

    var tituloHoja = this.TituloGrafTer + ' | ' + this.subTituloGrafTer;
    var nombreArch = `${this.translate.instant('riesgo-credito.concentracion.nombreArch')} ${this.mes} ${this.anio}`;
    this.excelservices.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato);
  }
}
